module.exports = __webpack_public_path__ + "static/media/inktoberSandWitch.5b8a6ae5.gif";